import {
    TEAM_SETTINGS_BASE_URL,
} from "./config";
import axios from "axios";
import {replaceWithCloudFrontUrl} from "./utils";

export async function getTeam() {
    return axios.get(TEAM_SETTINGS_BASE_URL)
        .then(replaceWithCloudFrontUrl);
}